import { Attachment } from "@livechat/design-system-icons";

import { AttachmentsFilterEnum } from "constants/filters/attachments-filter";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

import { AttachmentsFilterLabels } from "./AttachmentsFilter";

export const attachmentsFilterConfig: IFilterConfig = {
  title: "Attachments",
  icon: Attachment,
  multiple: false,
  getFilterLabelValues: (filterValues: AttachmentsFilterEnum): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }

    return [
      {
        key: filterValues[0],
        label: AttachmentsFilterLabels[filterValues],
      },
    ];
  },
};
